module.exports = __webpack_public_path__ + "media/Stepfather.ae3a95b3.mp3";